import { Box, Button, Typography } from '@mui/material';

import {
  updateSelectedFreq,
  usePersistentplanAndFreq,
} from 'store/planAndFreq';
import CuminButton from '@components/Button';
import { formattedString } from '@utils/formattedString';

import { useStyles } from './useStyles';
import theme from 'src/style-system/theme';

export const getBorderRadius = (index: number, length: number) => {
  if (index === 0) {
    return '8px 0 0 8px';
  } else if (index === length - 1) {
    return '0px 8px 8px 0px';
  } else {
    return '0';
  }
};

interface IFrequencyButtonGroup {
  frequencies: string[] | undefined;
}

const FrequencyButtonGroup = ({ frequencies }: IFrequencyButtonGroup) => {
  const planAndFreq = usePersistentplanAndFreq();

  const classes = useStyles();

  const handleFreqChange = (frequency: string) => {
    updateSelectedFreq(frequency);
  };

  return (
    <>
      <Box className={classes.desktopFreqBtnContainer}>
        {frequencies?.map((freq) => (
          <CuminButton
            color={
              planAndFreq.selectedFrequency === freq
                ? 'turmeric'
                : 'whitePepper'
            }
            variant="contained"
            textColor="garamMasala.main"
            borderRadius="25"
            border={`3px solid ${theme.palette.turmeric.main}`}
            height="51"
            width="max-content"
            onClick={() => handleFreqChange(freq)}
            className={classes.btn}
            key={freq}
          >
            {formattedString(freq)}
          </CuminButton>
        ))}
      </Box>
      <Box className={classes.mobilefreqBtnWrapper}>
        {frequencies?.map((freq, index) => (
          <Button
            variant="contained"
            color={
              planAndFreq.selectedFrequency === freq
                ? 'turmeric'
                : index % 2
                ? 'whitePepper'
                : 'offWhite'
            }
            key={freq}
            sx={{
              textTransform: 'none',
              width: '100px',
              height: '53px',
              padding: '8px 12px',
              borderRadius: getBorderRadius(index, frequencies.length),
              zIndex: planAndFreq.selectedFrequency === freq ? 1 : 0,
              transform:
                planAndFreq.selectedFrequency === freq ? 'scale(1.15)' : '',
            }}
            onClick={() => handleFreqChange(freq)}
          >
            <Typography variant="body2" color="garamMasala.main" align="center">
              {formattedString(freq)}
            </Typography>
          </Button>
        ))}
      </Box>
    </>
  );
};

export default FrequencyButtonGroup;
